import appAxios from "services/axios";

export const automationRunsService = {
    getAllByAutomationID: async (automationID: number) => {
        const orgID = localStorage.getItem('orgID')
        if (!orgID) {
            throw new Error('Org ID is not set')
        }
        const { data } = await appAxios.get(`/admin/orgs/${orgID}/automation-runs?automationID=${automationID}`)
        return data
    }
}